import React from 'react';
import {
  makeStyles,
  OutlinedTextFieldProps,
  TextField as MuiTextField,
  Theme
} from '@material-ui/core';
import { clsx } from '@components/Provider';
import NumberFormat from 'react-number-format';

export const CurrencyFormatInput = (props: any) => {
  const { inputRef, onChange, ...rest } = props;
  return (
    <NumberFormat
      {...rest}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value
          }
        });
      }}
      isAllowed={({ value }) => value.length <= 10}
      thousandSeparator
      decimalScale={0}
      allowNegative={false}
    />
  );
};

interface CustomizedOutlinedTextFieldProps
  extends Omit<Partial<OutlinedTextFieldProps>, 'variant' | 'size'> {
  maxWidth?: number;
  align?: 'right' | 'left' | 'center';
  size?: 'small' | 'medium' | 'large';
}

const OutlinedTextField = ({
  maxWidth,
  className,
  align = 'right',
  multiline = false,
  size = 'medium',
  ...rest
}: CustomizedOutlinedTextFieldProps) => {
  const classes = useStyles({ maxWidth, align, multiline, size });

  return (
    <MuiTextField
      {...rest}
      multiline={multiline}
      className={clsx(
        classes.root,
        {
          [classes.inputAlignment]: align
        },
        className
      )}
      variant="outlined"
    />
  );
};

export default OutlinedTextField;

const useStyles = makeStyles<
  Theme,
  Pick<
    CustomizedOutlinedTextFieldProps,
    'maxWidth' | 'align' | 'multiline' | 'size'
  >
>((theme) => {
  return {
    root: {
      maxWidth: ({ maxWidth }) => maxWidth,
      '& .MuiInputBase-input': {
        height: '1rem',
        paddingTop: ({ size }) => {
          if (size === 'large') {
            return 12;
          }

          return 9;
        },
        paddingBottom: ({ size }) => {
          if (size === 'large') {
            return 12;
          }

          return 9;
        },
        fontSize: 14,
        lineHeight: '143%',
        letterSpacing: '-0.1px',
        marginRight: 4,
        [theme.breakpoints.down('md')]: {
          fontSize: 13,
          lineHeight: '140%',
          letterSpacing: '-0.1px',
          paddingTop: ({ size }) => {
            if (size === 'large') {
              return 12;
            }

            return 6;
          },
          paddingBottom: ({ size }) => {
            if (size === 'large') {
              return 12;
            }

            return 6;
          }
        }
      },
      '& .MuiOutlinedInput-adornedStart': {
        paddingLeft: 8,
        '& > p': {
          fontSize: 14,
          lineHeight: '143%',
          letterSpacing: '-0.1px'
        }
      },
      '& .MuiOutlinedInput-adornedEnd': {
        paddingRight: 8,
        '& > p ': { fontSize: 13, lineHeight: '140%', letterSpacing: '-0.1px' }
      },
      '& .MuiOutlinedInput-multiline': {
        padding: '0px 12px',
        '& .MuiOutlinedInput-inputMultiline': {
          paddingTop: 8,
          paddingBottom: 8
        }
      }
    },
    inputAlignment: {
      '& input': {
        textAlign: ({ align }) => align,
        '&::placeholder': {
          textAlign: ({ align }) => align
        }
      }
    }
  };
});
